import CancelableApi from "./CancelableApi";
import CancelableAxiosInstance from "./CancelableAxiosInstance";

export interface Task {
  id: string;
  type: string;
  state: string;
  desc: string;
  exportedItemPerMin: number;
  estimatedEnd: string;

  success: number;
  failure: number;
  total: number;

  updated: string;
}

export default class TaskApi extends CancelableApi {
  static with(axios: CancelableAxiosInstance) {
    return new TaskApi(axios);
  }

  postImportPartFile(file: File): Promise<string> {
    return this.client
      .post("/tasks/import-parts", file, { headers: { "Content-Type": "application/json" } })
      .then((resp) => {
        return resp.data;
      });
  }

  postImportPartParamFile(file: File): Promise<string> {
    return this.client
      .post("/tasks/import-part-params", file, { headers: { "Content-Type": "application/json" } })
      .then((resp) => {
        return resp.data;
      });
  }

  postImportAiRegionFile(file: File): Promise<string> {
    return this.client
      .post("/tasks/import-ai-regions", file, { headers: { "Content-Type": "application/json" } })
      .then((resp) => {
        return resp.data;
      });
  }

  getTasks(): Promise<Task[]> {
    return this.client.get("/tasks").then((response) => response.data);
  }

  getTaskTypes(): Promise<string[]> {
    return this.client.get("/task-types").then((response) => response.data);
  }

  launchTask(taskType: string, params: any): Promise<Task> {
    return this.client.post("/tasks/" + taskType, { params }).then((response) => response.data);
  }
}
